import { Component } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
import { AccountService } from '../account.service';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'confirm-reset-password',
  templateUrl: './confirmResetPassword.component.html',
  styleUrls: [
    '../account.scss',
    '../container/container.component.scss',
    './confirmResetPassword.component.scss',
  ],
})
export class ConfirmResetPasswordComponent {
  public user = {
    password: '',
    passwordConfirmation: '',
    errors: {
      password: [],
    },
  };
  public isLoading;

  constructor(
    private accountService: AccountService,
    private toasterService: ToasterService,
    private translate: TranslateService,
    private router: Router,
    private firebaseService: FirebaseService
  ) {}

  public isFormReady() {
    return (
      this.user.password &&
      this.user.password === this.user.passwordConfirmation &&
      !this.isLoading
    );
  }

  public onSubmit() {
    if (!this.isFormReady()) {
      return null;
    }

    this.user['errors'] = { password: [] };
    this.isLoading = true;
    this.accountService.changePassword(this.user.password).subscribe(
      () => {
        this.translate
          .get('password_changed_successfully')
          .subscribe(message => {
            this.router.navigate(['/account/login']);
            this.toasterService.pop('success', undefined, message);
          });
        this.firebaseService.logEvent('login_password_reset', {});
      },
      data => {
        const error = data.error;
        this.isLoading = false;
        if (error.detail) {
          this.toasterService.pop('error', undefined, error.detail);
        }
        if (error.password) {
          this.user.errors.password = error.password;
        }
      }
    );
  }
}
